export default __webpack_public_path__ + "static/bnr-usedcar-f2b950b5765854f24f8f98e21a3c862f.avif";